query DataAccessPolicyCommonData {
  companyDepartmentGroups(
    orderBy: DEPARTMENT_GROUP_BY_DEPARTMENT_GROUP_ID__NAME_ASC
  ) {
    nodes {
      departmentGroupId
      departmentGroup {
        name
      }
    }
  }

  companyBusinessUnits(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
}
